import styled from "styled-components";

type Variant = "error" | "warning" | "info" | "success" | "default" | "active";

export type PaperProps = {
  variant?: Variant;
  active?: boolean;
  background?: string;
  flex?: boolean;
};

export const Paper = styled.div<PaperProps>`
  ${({ flex }) =>
    flex
      ? `
      display: flex;
      flex-direction: column;
      `
      : ""}

  line-height: 1.3;
  border-radius: 5px;

  ${({ variant, theme }) => {
    switch (variant) {
      case "success": {
        return `
          border: 2px solid ${theme.colors.greenBg};
          background: ${theme.colors.greenBg};
        `;
      }
      case "error": {
        return `
          border: 2px solid ${theme.colors.redBg};
          background: ${theme.colors.redBg};
        `;
      }
      case "warning": {
        return `
          border: 2px solid ${theme.colors.yellowBg};
          background: ${theme.colors.yellowBg};
        `;
      }
      case "info": {
        return `
          border: 2px solid ${theme.colors.coeblue11};
          background: ${theme.colors.coeblue11};
        `;
      }
      case "default": {
        return `
          border: 2px solid ${theme.colors.black4};
          background: ${theme.colors.black4};
        `;
      }
      default: {
        return `
          border: 2px solid ${theme.colors.black4};
          background: ${theme.colors.black4};
        `;
      }
    }
  }}

  ${({ active, theme }) =>
    active
      ? `
        border: 2px solid ${theme.colors.coeblue4};
    `
      : ""}

  ${({ background }) =>
    background
      ? `
      border: 2px solid ${background};
      background: ${background};
    `
      : ""}
`;

type PaperContentProps = {
  size?: "xxsmall" | "xsmall" | "small" | "none" | number;
  flex?: boolean;
};

export const PaperContent = styled.div<PaperContentProps>`
  padding: ${({ size }) => {
    if (typeof size === "number") {
      return `${size}px`;
    }

    switch (size) {
      case "xxsmall": {
        return "4px 6px";
      }
      case "xsmall": {
        return "8px 10px";
      }
      case "small": {
        return "10px 12px";
      }
      case "none": {
        return "0";
      }
      default: {
        return "16px";
      }
    }
  }};

  ${({ flex }) =>
    flex
      ? `
      display: flex;
      flex-direction: column;
      `
      : ""}
`;
